import script from "./ClientBlockPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientBlockPage.vue?vue&type=script&setup=true&lang=ts"

import "./ClientBlockPage.vue?vue&type=style&index=0&id=c35141b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c35141b6"]])

export default __exports__